<template>	
    <v-row>
      <v-dialog v-model="showDialog" scrollable max-width="750px">
        <v-skeleton-loader
        v-if="loading"
          type="article, actions"
        ></v-skeleton-loader>
        <v-card v-if="!loading">
          <v-card-title style="padding: 10px 0 0 10px; height: 80px;">
            <v-col cols="12">
                          <span style="font-size: 20px;">
                              {{ !data.id ? $t('wkt.admin.activity-types.edit-activity-types.edit-title-new') : $t('wkt.admin.activity-types.edit-activity-types.edit-title-edit' )}}
                              
                          </span>
            </v-col>
          </v-card-title>
            <v-card>
                  <v-tabs v-model="tab" v-if="!loading">
                    <v-tab href="#setting" >{{ $t('wkt.admin.activity-types.edit-activity-types.tab.setting-title') }}</v-tab>
                    <v-tab href="#access">{{ $t('wkt.admin.activity-types.edit-activity-types.tab.access-title') }}</v-tab>
                  </v-tabs>
                  
                    <v-tabs-items v-if="!loading" v-model="tab" style="padding: 6px;">
                      
                          <v-tab-item value="setting" style="padding: 6px;">
                            <v-form ref="form" style="padding: 6px;">
                                  <v-row style="margin-top: 20px;">

                                      <v-col cols="6">                
                                            <v-text-field
                                                v-model="data.description"
                                                :label="$t('wkt.admin.activity-types.edit-activity-types.description')"
                                                autocomplete="none"
                                                max="200"
                                            />
                                      </v-col>
                                      
                                      <v-col cols="6">                
                                          <v-text-field
                                              v-model="data.internalCode"
                                              :label="$t('wkt.admin.activity-types.edit-activity-types.internal-code')"
                                              autocomplete="none"
                                              max="400"
                                          />
                                      </v-col>
                
                                          <v-col cols="12">                
                                          <v-text-field
                                              v-model="data.hourlyCost"
                                              :label="$t('wkt.admin.activity-types.edit-activity-types.hourly-cost')"
                                              autocomplete="none"
                                              max="400"
                                          />
                                      </v-col>

                                        <v-col cols="6">
                                          <span style="position: relative; top: 22px; font-size: 15px;">
                                            {{ $t('wkt.admin.activity-types.edit-activity-types.workable') }}
                                          </span>                
                                          <v-switch style="float: right;"
                                            v-model="data.workable">
                                          </v-switch>
                                        </v-col>

                                        <v-col cols="6">
                                          <span style="position: relative; top: 22px; font-size: 15px;">
                                            {{ $t('wkt.admin.activity-types.edit-activity-types.enabled') }}
                                          </span>                
                                          <v-switch style="float: right;"
                                            v-model="data.enabled">
                                          </v-switch>
                                        </v-col>

                                  </v-row>
                               </v-form>
                          </v-tab-item>
                      
                        <v-tab-item value="access">
                          <v-form ref="form">
                                <v-row style="margin-top: 20px;" >
                                    <v-col cols="12">                
                                        <v-select 
                                          v-model="data.accessType"
                                          :items="accessTypes"
                                          item-text="name"
                                          item-value="id"
                                          :label="$t('wkt.admin.activity-types.edit-activity-types.access-type_placeholder')"    
                                          />
                                    </v-col>

                                    <v-col cols="12" v-if="data.accessType === 2">
                                          <v-select 
                                             clearable
                                             chips
                                             v-model="data.workplaces"
                                             :items="workPlacesByProfile"
                                             multiple
                                             item-text="name"
                                             item-value="id"
                                             :label="$t('wkt.admin.activity-types.edit-activity-types.workplaces')"
                                          />
                                    </v-col>

                                    <v-col cols="12" v-if="data.accessType === 2">
                                          <v-select
                                             clearable
                                             chips
                                             multiple
                                             v-model="data.departments"
                                             :items="departmentsByProfile"
                                             item-text="name"
                                             item-value="id"
                                             :label="$t('wkt.admin.activity-types.edit-activity-types.departments')"
                                          />
                                    </v-col>

                                       <v-col cols="12" v-if="data.accessType === 3">
                                          <v-select
                                             clearable
                                             chips
                                             multiple
                                             v-model="data.projects"
                                             :items="projectsList"
                                             item-text="shortName"
                                             item-value="id"
                                             menu-props="bottom, offsetY"
                                             :label="$t('wkt.admin.activity-types.edit-activity-types.projects')"
                                          />
                                    </v-col>

                                    <v-col cols="12" v-if="data.accessType === 4">                
                                          <v-autocomplete
                                             v-model="data.employees"
                                             :items="employees"
                                             item-value="id"
                                             menu-props="bottom, offsetY"
                                             :label="$t('wkt.admin.activity-types.edit-activity-types.access-type_employees')"
                                             multiple
                                             chips
                                             clearable
                                             >
                                             <template v-slot:selection="{item}">
                                                {{ `${item.firstname}, ${item.lastname}` }}
                                             </template>
                                             <template v-slot:item="{item}">
                                                {{ `${item.firstname}, ${item.lastname}` }}
                                             </template>
                                          </v-autocomplete>
                                      </v-col>
                                    <v-col cols="12" v-if="data.accessType === 5">   
                                        <div style="display: flex;justify-content: center;">
                                          <textarea  ref="scriptArea" v-model="data.script" rows="10" cols="95" ></textarea>
                                        </div>
                                        <div style="display: flex;justify-content: flex-end;">
                                          <button @click="runScript" style="color: rgb(24, 94, 169);margin-right: 2rem;margin-bottom: 2rem; margin-top: 6px;"><v-icon color="rgb(24, 94, 169)" style="margin-top: -3px;font-size: 2rem;">arrow_right</v-icon>PROBAR SCRIPT</button>
                                        </div>
                                 </v-col>
                                </v-row>
                           </v-form>
                        </v-tab-item>
                    </v-tabs-items>
            </v-card>
         
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn v-if="data.id" color="#ff0000" @click="confirmDelete()">
                          <v-icon left color="#ffffff">delete</v-icon>
                          <span style="color: #ffffff;">{{ $t('wkt.admin.common.dialog-buttons.delete').toUpperCase() }}</span>
                      </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="#185EA9" text @click="onSave()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.ok').toUpperCase() }}</v-btn>
            <v-btn text @click="showDialog=false" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
          <ConfirmDialog ref="dlgConfirm"
              v-bind:title="$t('wkt.admin.report-types.edit-report-type.confirm-dialog.title')"
              v-bind:message="$t('wkt.admin.report-types.edit-report-type.confirm-dialog.text')"
              v-bind:titleOk="$t('wkt.admin.common.dialog-buttons.delete')"
              v-bind:titleCancel="$t('wkt.admin.common.dialog-buttons.cancel')"
              v-on:confirmed="deleteItem()"
          />
    </v-row>	
  </template>
  
<script>
import BaseModule from '../../common/BaseModule.js'
import ConfirmDialog from '../../common/ConfirmDialog'
import api from '../../../api/worktime'
import gwt from '../../../api/gwt'


export default {
   name: 'ActivityTypeDialog',
   mixins: [BaseModule],
   components: {
      ConfirmDialog
   },
   data() {
      return {
         showDialog: false,
         loading: true,
         tab: 0,
         data: {},
         accessTypes: [
                        {id:1, name:'Toda la empresa'},
                        {id:2, name:'Un grupo concreto'},
                        {id:3, name:'Equipos o proyectos'},
                        {id:4, name:'Trabajadores concretos'},
                        {id:5, name:'Script'}
                     ],
         workPlacesByProfile: [],
         departmentsList: [],
         departmentsByProfile: [],
         projectsList: [],
         employees: [],
         workplaceIds: [],
         departmenIds: [],
         projectIds: [],
         selectWorkplaces: false,
         content: '',
      }
   },
   mounted() {
   // Obtén la referencia del área de script
   const scriptArea = this.$refs.scriptArea;
   
   // Inicializa CodeMirror
   const cm = this.initScriptArea(scriptArea);

   // Llama a setScriptAreaContent para establecer el contenido inicial si es necesario
   this.setScriptAreaContent(cm, this.data.script);
   },
   methods: {

      // eslint-disable-next-line no-unused-vars
      open: function (action, payload) {

         this.showDialog = true;

         if (this.$refs.form) {
            this.$refs.form.resetValidation();
         }

           this.data = {
            companyId: gwt.getSessionProfile().companyId,
            workplaces: null,
            departments: null,
            employees: null,
            projects: null
         };

         if (!payload) { // Estamos creando un elemento
            this.getWorkPlacesByProfile(); 
            this.getDepartmentsByProfile();
            this.getProjects();
            this.getStaff()
            this.data = {
               companyId: gwt.getSessionProfile().companyId
            };
            this.loading = false; 
            return;
         }

         this.loading = true;
         api.getActivityTypeById(payload, res => {
            this.getWorkPlacesByProfile()
            this.getDepartmentsByProfile()
            this.getProjects();
            this.getStaff()
            this.data = res; 
            this.data.workplaces =  this.getWorkplaceIds();
            this.data.departments = this.getDepartmentsIds()
            this.data.projects = this.getProjectIds();
            this.data.employees = this.getEmployeeIds();
            this.loading = false;
         }, error => {
            this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            this.loading = false;
         })

      },
      onSave: function () {
         if (!this.$refs.form.validate()) {
            return;
         }

         this.loading = true;

         if (this.data.workplaces) {
            this.data.workplaces = this.data.workplaces.join(",");
         }
         if (this.data.departments) {
            this.data.departments = this.data.departments.join(",");
         }
         if (this.data.projects) {
            this.data.projects = this.data.projects.join(",");
         }
         if (this.data.employees) {
            this.data.employees = this.data.employees.join(",");
         }
         
         // eslint-disable-next-line no-unused-vars
         api.storeActivityType(this.data,res => {
               this.loading = false;
               if (res.rsOK) {
                  this.$emit('refresh');
                  this.showDialog = false;
               } else {
                  this.$emit('show-alert',{ text: res.message, color: 'error', timeout: 3000 });
               }
            },
            error => {
               this.$log.error(error);
               this.loading = false;
               this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            });
      },
      getWorkPlacesByProfile() {
         this.workPlacesByProfile = [];
         api.getWorkPlaces(
         data => {
            //this.workPlacesByProfile = data;
            this.fillWorkplaceComboBox(data);
         }, 
         error => {
            console.log(error);
            this.doShowAlert({ text: error.message, color: 'error', timeout: 3000 });
         });
      },
        getDepartmentsByProfile() {
         this.departmentsByProfile = [];
         api.getStaff(
         data => {
            //this.departmentsByProfile = data;
            this.fillDepartmentsComboBox(data)
         }, 
         error => {
            console.log(error);
            this.doShowAlert({ text: error.message, color: 'error', timeout: 3000 });
         });
      },
      getProjects() {
         api.getProjects(
         data => {
            this.projectsList = data;
         }, 
         error => {
            console.log(error);
            this.doShowAlert({ text: error.message, color: 'error', timeout: 3000 });
         });
      },
      getStaff() {
         api.getStaff(
         data => {
            this.employees = data;
            this.getAllEmployees(this.employees)
         }, 
         error => {
            console.log(error);
            this.doShowAlert({ text: error.message, color: 'error', timeout: 3000 });
         });
      },
      getAllEmployees(departments) {
            this.employees = [];
            for (let i = 0; i < departments.length; i++) {
               this.employees = [...this.employees, ...departments[i].employees];
            }
         },
      fillWorkplaceComboBox(workplaces) {
         let profile = null;
         if (gwt.getSessionInformation() !== null) {
            profile = gwt.getSessionInformation().profiles.find(x => x.companyId === gwt.getSessionInformation().company.id && x.employeeId === gwt.getSessionInformation().employee.id);
         }
         
         if (profile.workplaces == null) {
            this.workPlacesByProfile = workplaces;
         } else {
            const workplaceIds = this.getEntityIdsFromStringIds(profile.workplaces);
            if (workplaceIds != null) {
               this.workPlacesByProfile = workplaces.filter(x => workplaceIds.includes(x.id));
            } else if (this.isEmulationEnabled()) {
               this.workplacesByProfile = workplaces;
            }
         }
      },
      fillDepartmentsComboBox(allDepartments) {
         let profile = null;
         if (gwt.getSessionInformation() !== null) {
            profile = gwt.getSessionInformation().profiles.find(x => x.companyId === gwt.getSessionInformation().company.id && x.employeeId === gwt.getSessionInformation().employee.id);
         }
         if (this.profile !== null) {
        // Workaround para copiar profundamente la lista de trabajadores ****************
         this.departmentsByProfile = allDepartments.map((d) => {
          const clone = {
            id: d.id,
            name: d.name,
            companyId: d.companyId,
            employees: [...d.employees], // Copiar la lista de empleados
          };
          return clone;
        });
       
 
         if (profile.departments != null) {
					const departmentIds = this.getEntityIdsFromStringIds(profile.departments);
               if (departmentIds != null) {
                  this.departmentsByProfile = allDepartments.filter(x => departmentIds.includes(x.id));
               }
            }
            if (profile.onlyMyTeam.valueOf() && gwt.getSessionInformation().myTeam != null) {
						const myTeamIds = gwt.getSessionInformation().myTeam().map(x => x.id);
					for (const dep of this.departmentsByProfile) {
                        dep.employees.filter(x => !myTeamIds.includes(x.id));
                     }
						} else if (profile.workplaces != null) {
							const workplaceIds = this.getEntityIdsFromStringIds(profile.workplaces);
					for (const dep of this.departmentsByProfile) {
                        dep.employees.filter(x => !workplaceIds.includes(x.workplaceId));
                     }
						}
					} else if (this.isEmulationEnabled()) {
						this.departmentsByProfile = allDepartments;
					}
      },
      getWorkplaceIds() {
         let ids = [];

         if (!this.data.workplaces) {
            return ids;
         }

         let workplaceIds = this.data.workplaces.split(",");

         for (let workplaceId of workplaceIds) {
            ids.push(Number(workplaceId));
         }

         return ids;
      },
      getDepartmentsIds() {
         let ids = [];

         if (!this.data.departments) {
            return ids;
         }

         let departmentIds = this.data.departments.split(",");

         for (let departmentId of departmentIds) {
            ids.push(Number(departmentId));
         }

         return ids;
      },
      getProjectIds() {
         let ids = [];

         if (!this.data.projects) {
            return ids;
         }

         let projectIds = this.data.projects.split(",");

         for (let projectId of projectIds) {
            ids.push(Number(projectId));
         }

         return ids;
      },
      getEmployeeIds() {
         let ids = [];

         if (!this.data.employees) {
            return ids;
         }

         let employeeIds = this.data.employees.split(",");

         for (let employeeId of employeeIds) {
            ids.push(Number(employeeId));
         }

         return ids;
      },
      runScript() {
         this.loading = true;
         this.data.workplaces = this.data.workplaces ? this.data.workplaces.join(",") : null;
         this.data.departments = this.data.departments ? this.data.departments.join(",") : null;
         this.data.projects = this.data.projects ? this.data.projects.join(",") : null;
         this.data.employees = this.data.employees ? this.data.employees.join(",") : null;
         api.testActivityTypeScript(this.data,res => {
               this.loading = false;
               if (res.rsOK && res.output !== "true" && res.output !== "false") {
                     res.rsOK = false;
                     res.exception = "Return object is not a boolean value";
                  }
               if (res.rsOk) {
                  let msg = res.output;
                  if (res.debug) {
                     msg += "<BR>--------------------------<BR>" + res.debug.replace("\n", "<BR>");
                  }
                  // Muestra un mensaje de éxito
                  this.$emit('show-alert',{ text: msg, color: 'green', timeout: 3000 });
                  } else {
                  // Muestra un mensaje de error
                   this.$emit('show-alert',{ text: res.exception, color: 'red', timeout: 3000 });
                  }
                  },
                  error => {
                     this.$log.error(error);
                     this.loading = false;
                     this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
                  }); 
      },
      initScriptArea (scriptArea) {
        return window.CodeMirror(scriptArea, {
            mode:  "javascript", 
            theme: "material"
        });
      },
      setScriptAreaContent (scriptArea, content) {
        try {
            scriptArea.setValue(content?content:""); 
            scriptArea.focus();
        }catch(error) {
          console.log(error);
        }
      },
      getScriptAreaContent (scriptArea){
        return scriptArea.getValue();
      },
      confirmDelete() {
         this.$refs.dlgConfirm.confirm(this.data);
      },
      deleteItem() {
         this.loading = true;
         // eslint-disable-next-line no-unused-vars
         api.getActivityCountByActivityType(this.data.id, 
         res => {
               this.loading = false;
               if (res > 0) {
                  this.showDialog = false;
                  const message = res === 1
                     ? 'No se puede borrar este tipo de actividad, hay 1 actividad que la tiene asignada.'
                     : `No se puede borrar este tipo de actividad, hay ${res} actividades que la tienen asignada.`;
                  this.$emit('show-alert',{ text: message, color: 'error', timeout: 3000 });
               } else {
                      // eslint-disable-next-line no-unused-vars
                  api.deleteActivityType(this.data.id, res => {
                  this.showDialog = false;
                  this.loading = false;
                  if (res && res.rsOK) {
                     this.$emit('refresh');
                  } else {
                     const msg = res && res.message ? res.message : 'No se pudo eliminar el tipo de actividad';
                     this.$emit('show-alert',{ text: msg, color: 'error', timeout: 3000 });
                  }
               },
                  (error) => {
                     this.loading = false;
                     this.showDialog = false;
                     this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
                  });
               }
            },
         (error) => {
            this.loading = false;
             this.showDialog = false;
            this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
         });
      },

   },
}
</script>
